export default "__VITE_ASSET__C6ZQX_Zs__"